import { t } from "i18next";
import { TooltipHelp } from "../TooltipHelp";
import { cn } from "@/lib/utils";

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

export const UploadAudioButton = ({
  onClick,
  disabled = false,
}: Props): JSX.Element => {
  return (
    <div className="flex items-center gap-2">
      <button
        disabled={disabled}
        className={cn(
          "text-tinted-grey-3 text-base font-semibold cursor-pointer  underline ",
          disabled
            ? "cursor-not-allowed opacity-50"
            : "hover:text-primary hover:underline-offset-2 transition duration-300"
        )}
        onClick={onClick}
      >
        {t("visits.sidebar.uploadFile")}
      </button>
      <TooltipHelp content={t("error.formRecorder.supportedFormat")} />
    </div>
  );
};
